import { render, staticRenderFns } from "./emailCustomContent.vue?vue&type=template&id=28ffdec3&scoped=true&"
import script from "./emailCustomContent.vue?vue&type=script&lang=js&"
export * from "./emailCustomContent.vue?vue&type=script&lang=js&"
import style0 from "./emailCustomContent.vue?vue&type=style&index=0&id=28ffdec3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ffdec3",
  null
  
)

export default component.exports